<script>
  let {
    text = 'PAID',
    color = 'teal',
    rotation = -12,
  } = $props();

  const colorMap = {
    red: '#FF3B30',
    green: '#34C759',
    teal: '#20B2AA',
  };

  let stampColor = $derived(colorMap[color] || colorMap.teal);
</script>

<div
  class="receipt-stamp"
  style:--stamp-color={stampColor}
  style:--stamp-rotation="{rotation}deg"
>
  <span class="receipt-stamp__text">{text}</span>
</div>

<style>
  .receipt-stamp {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(var(--stamp-rotation));
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    z-index: 10;
  }

  .receipt-stamp__text {
    font-family: var(--font-mono);
    font-size: 36px;
    font-weight: 900;
    letter-spacing: 6px;
    text-transform: uppercase;
    color: var(--stamp-color);
    opacity: 0.8;
    border: 4px solid var(--stamp-color);
    border-radius: 8px;
    padding: 6px 20px;
    background: color-mix(in srgb, var(--stamp-color) 15%, transparent);
    box-shadow:
      inset 0 0 0 2px color-mix(in srgb, var(--stamp-color) 10%, transparent);
    user-select: none;
    white-space: nowrap;
  }
</style>
